import React, { useLayoutEffect, useState } from "react";
import {
    Grid,
    TextField,
    Typography,
    Paper,
    Autocomplete,
    Tooltip,
    Snackbar,
    IconButton,
    List,
    ListItem,
    ListItemText } from "../ui";
import Loader from "../global/loader/Loader";
import "./Profile.css";
import {
  UPDATE_PROFILE,
  setProileResponse,
  SUCCESS,
  OfferType,
  CART_INITIAL_STATE,
  CartDets,
  isRoleAllowed,
  INITIAL_SHOP_HASH,
  GETSINGLECONFIGS,
  CUSTLOYALITYPOINT,
  getPreUrlAccordingToCart,
  UPDATEACTIVESHOPSESSION,
  printInfoLog,
  printDebugLog,
  TABLESYSTEMBILL,
  VALIDITYEXPIREDERR,
  updateKitchenSessionState,
  isOtherRoleAllowed,
  OTHER_ADMIN_RIGHTS
} from "../../constants/constant";
import axios from "axios";
import {
    FormControl,
    RadioGroup,
    FormControlLabel,
    FormLabel,
    Radio,
} from "../ui";
import { useDispatch, useSelector } from "react-redux";
import { Box } from "../ui";
import { setCartType, setActiveShopHash, setBaseCateogoryData } from "../../actions";
import CheckCircleIcon from '../ui/icons/CheckCircle';
import CancelIcon from '../ui/icons/Cancel';
import { snpAxios } from '../global/api';
import SnpButton from "../global/SnpButton";
import { useNavigate } from "react-router-dom";
import AddIcon from "../ui/icons/Add";
import DeleteIcon from "../ui/icons/Delete";
import ArrowUpwardIcon from '../ui/icons/ArrowUpward';
import ArrowDownwardIcon from '../ui/icons/ArrowDownward';

export default function Profile({ throwValidityError }) {

    const dispatch = useDispatch();
    const storeCartType = useSelector(state => state.setCartTypeReducer.cartType);
    const storeActiveShopHash = useSelector(state => state.setActiveShopHashReducer.activeShopHash);
    const storeApiUrl = useSelector(state => state.setApiUrlReducer.MAINURL.INITIAL_BASE_URL);
    const navigate = useNavigate();
    const [isDataLoaded, setDataLoaded] = useState(false);
    const [isNotAllowed, setNotAllowed] = useState(false);
    const [pointCostAllowed, setPointCostAllowed] = useState(false);
    const [profileData, setProfileData] = useState({
        userEmail: "",
        companyName: "",
        userName: "",
        companyWebAddress: "",
        companyMail: "",
        validity: "",
        startDate: 0,
        loginBackGroundImage: "",
        pointDenom: 0,
        pointDenomVal: 0.0,
        pointValue: 0.0,
        pointRealCostPer: 0.0,
        panDetails: "",
    });

    const [payMethod, setPayMethod] = useState("");
    const [listOnlinePayMethod, setListOnlinePayMethod] = useState([]);

    const [selShop, setSelShop] = useState(INITIAL_SHOP_HASH);
    const [loyaityPoints, setLoyaityPoints] = useState(false);
    const [tableSystemAllowed, setTableSystemAllowed] = useState(false);
    const setPointCostValue = (value) => {
        //console.log("setPointCostValue",value)
        if (parseInt(value) === 1)
            setPointCostAllowed(false);
        else
            setPointCostAllowed(true);
    }
    const handleInputChange = (event) => {
        const { name, value } = event.target;
        //console.log("handleInputChange", name, value);
        if (name === 'pointDenom') {
            setPointCostValue(value);
        }
        setProfileData({
            ...profileData,
            [name]: value,
        });
    };


    const handleMoveMethod = (fromIndex, toIndex) => {
        setListOnlinePayMethod((prev) => {
            const updated = [...prev];
            const [movedItem] = updated.splice(fromIndex, 1);
            updated.splice(toIndex, 0, movedItem);
            return updated;
        });
    };


    const handleAddMethod = () => {
        if (payMethod.trim()) {
            setListOnlinePayMethod([...listOnlinePayMethod, payMethod.trim()]);
            setPayMethod("");
        }
    };

    const handleRemoveMethod = (index) => {
        const updated = [...listOnlinePayMethod];
        updated.splice(index, 1);
        setListOnlinePayMethod(updated);
    };

    const getPointCost = () => {
        let data = (isNotAllowed || !pointCostAllowed);
        //console.log("getPointCost",isNotAllowed,pointCostAllowed,data);
        return data;
    }

    const getSingleConfigs = (mConfigName) => {
        let cUrl = storeApiUrl.BACKEND_BASE_URL + getPreUrlAccordingToCart(storeActiveShopHash.cartType) + GETSINGLECONFIGS + `?adminId=${CART_INITIAL_STATE.apiToken}`
            + `&configName=${mConfigName}&shopHash=${storeActiveShopHash.id}`;
        let data = {};
        //const urlFormattedString = encodeURIComponent(cUrl);
        //printLog("getSingleConfigs => ", cUrl);
        axios.get(
            cUrl,
            data
        )
            .then((response) => {
                //printLog("getSingleConfigs<=",response.data);
                if (response.data !== '') {
                    if (mConfigName === CUSTLOYALITYPOINT)
                        setLoyaityPoints(response.data === 'Yes')
                    else if (mConfigName === TABLESYSTEMBILL)
                        setTableSystemAllowed(response.data === 'Yes');
                }
            }).catch((error) => {
                //printLog("error : ", error);
                //window.location.href = "#/error";
            });
    };

    const handleProfileSubmit = async () => {
        try {
            const catgUrl = `${storeApiUrl.BACKEND_BASE_URL}${UPDATE_PROFILE}`;
            setDataLoaded(false);
            //console.log(jsonObject);
            const filledData = {
                jcJson: {
                    apiToken: CART_INITIAL_STATE.apiToken,
                    shopHash: storeActiveShopHash.id,
                    companyName: profileData.companyName,
                    companyMail: profileData.companyMail,
                    companyWebAddress: profileData.companyWebAddress,
                    onlinePayMethod: listOnlinePayMethod,
                    panDetails: profileData.panDetails,
                    shopBackgroundImage: profileData.loginBackGroundImage,
                    pointDenom: Number(profileData.pointDenom ?? OfferType.No_Offer),
                    pointDenomVal: Number(profileData.pointDenomVal ?? 0),
                    pointValue: Number(profileData.pointValue ?? 0),
                    pointRealCostPer: Number(profileData.pointRealCostPer ?? 0),
                }
            };
            const response = await snpAxios.post(catgUrl, filledData);
            if (response.data.status === SUCCESS) {
                setProileResponse(profileData, listOnlinePayMethod);
            }
        } catch (error) {
            console.error("handleProfileSubmit : ", error);
        } finally {
            setDataLoaded(true);
        }
    };


    useLayoutEffect(() => {
        //console.log('Printing storeActiveShopHash : ', storeCartType,storeActiveShopHash);
        getSingleConfigs(TABLESYSTEMBILL);
        getSingleConfigs(CUSTLOYALITYPOINT);
        setNotAllowed(!isOtherRoleAllowed(OTHER_ADMIN_RIGHTS));
        setPointCostValue(CART_INITIAL_STATE.pointMethod.pointDenom);
        setSelShop(storeActiveShopHash);
        setProfileData(prev => ({
            ...prev,
            userEmail: CART_INITIAL_STATE.userEmail,
            companyName: CART_INITIAL_STATE.companyName,
            userName: CART_INITIAL_STATE.userName,
            companyWebAddress: CART_INITIAL_STATE.companyWebAddress,
            panDetails: CART_INITIAL_STATE.activeShopHash.panDetails,
            companyMail: CART_INITIAL_STATE.companyMail,
            validity: CART_INITIAL_STATE.validity,
            startDate: CART_INITIAL_STATE.startDate,
            pointDenom: CART_INITIAL_STATE.pointMethod.pointDenom,
            pointDenomVal: CART_INITIAL_STATE.pointMethod.pointDenomVal,
            pointValue: CART_INITIAL_STATE.pointMethod.pointValue,
            pointRealCostPer: CART_INITIAL_STATE.pointMethod.pointRealCostPer,
        }));
        setListOnlinePayMethod(CART_INITIAL_STATE.onlinePayMethod);
        setDataLoaded(true);
    }, [storeCartType, storeActiveShopHash, storeApiUrl]);

    const getKeyByValue = (CartDets, value) => {
        //console.log("getKeyByValue",CartDets,value);
        return value.location + "(" + Object.keys(CartDets).find(key => CartDets[key] === value.cartType) + ")";
    }

    const updateCartValue = (event, selectedHash) => {
        //let selectedHash = e.target.value;
        if (selectedHash != null) {
            //console.log("updateCartValue",selectedHash);


            const cartUrl = storeApiUrl.BACKEND_BASE_URL + UPDATEACTIVESHOPSESSION;
            const data = {
                jcJson: {
                    apiToken: CART_INITIAL_STATE.apiToken,
                    shopHash: selectedHash.id,
                },
            };
            //  console.log("getRestoDetails  => ",data);
            snpAxios
                .post(cartUrl, data)
                .then((response) => {
                    // console.log("response  => ", response.data);
                    printDebugLog("updateCartValue", response.data);
                    if (response.data.status === SUCCESS) {
                        const responseShopHash = selectedHash;
                        responseShopHash.defScreen = response.data.jcJson.defScreen;
                        responseShopHash.companyName = response.data.jcJson.companyName;
                        responseShopHash.companyWebAddress = response.data.jcJson.companyWebAddress;
                        responseShopHash.companyMail = response.data.jcJson.companyMail;
                        responseShopHash.packages = response.data.jcJson.packages;
                        responseShopHash.onlineDelvMethod = response.data.jcJson.onlineDelvMethod;
                        responseShopHash.validity = response.data.jcJson.validity;
                        responseShopHash.totalValidity = response.data.jcJson.totalValidity;
                        responseShopHash.startDate = response.data.jcJson.startDate;
                        responseShopHash.originalStartDate = response.data.jcJson.originalStartDate;
                        responseShopHash.defBalanceType = response.data.jcJson.defBalanceType;
                        responseShopHash.kotCopiesAllowed = response.data.jcJson.kotCopiesAllowed;
                        responseShopHash.fcmNotificationAllowed = response.data.jcJson.fcmNotificationAllowed ?? false;
                        responseShopHash.defBillUi = Number(response.data.jcJson.defBillUi);
                        updateKitchenSessionState(responseShopHash, response.data.jcJson);
                        dispatch(setActiveShopHash(responseShopHash));
                        dispatch(setCartType(responseShopHash.cartType));
                        const worker = new Worker(new URL('../billing/GetDataFromDbWorker.js', import.meta.url));
                        worker.postMessage(responseShopHash.id);
                        worker.onmessage = (e) => {
                            const savedData = e.data;
                            printDebugLog("GetDataFromDbWorker Profile", savedData);
                            if (savedData !== undefined && savedData.data !== undefined) {
                                if (!"fullData" === savedData.type) {
                                    dispatch(setBaseCateogoryData(savedData.data.value));
                                }
                            }
                        };

                        worker.onerror = (error) => {
                            console.error("Worker error:", error);
                        };


                        navigate("/dashboard");
                        setSnackBar({
                            ...snackBar, snackBarMsg: "Changed to " + selectedHash.shop + " successfully done.", snackBarOpen: true,
                        })
                    } else {
                        setSnackBar({
                            ...snackBar, snackBarMsg: "Changed to " + selectedHash.shop + " not happen.Try again!", snackBarOpen: true,
                        })
                    }
                })
                .catch((error) => {
                    printInfoLog("errr ", error);
                    if (VALIDITYEXPIREDERR === error.code) {
                        throwValidityError(error.message);
                    } else {
                        setSnackBar({
                            ...snackBar, snackBarMsg: "Changed to " + selectedHash.shop + " not happen.Try again!", snackBarOpen: true,
                        })
                    }
                });



        }

        //dispatch(setCartType(selectedHash.cartType));
        //let index = parseInt(e.target.value) -1;
        //let activeHash = CART_INITIAL_STATE.listShopHash[index];
        //console.log("updateCartValue",index,activeHash);
        // dispatch(setActiveShopHash(selectedHash));
        //console.log(e.target.value);
        //setComponentIndex((selectedHash.cartType === CartDets.Resto) ? 7 : 0);
    }

    const INITIAL_SNACK_BAR = {
        snackBarOpen: false, snackBarMsg: ""
    };

    const [snackBar, setSnackBar] = useState(INITIAL_SNACK_BAR);
    const handleSnackClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setSnackBar(INITIAL_SNACK_BAR);
    };

    return (
        <React.Fragment>
            <Snackbar
                open={snackBar.snackBarOpen}
                autoHideDuration={3000}
                message={snackBar.snackBarMsg}
                onClose={handleSnackClose}
            />
            {
                isDataLoaded ?
                    <div >

                        <Grid container spacing={1}>
                            <Grid item md={12} xs={12} lg={12} sm={12}>
                                <Paper
                                    elevation={0}
                                    autoHeight
                                    sx={{
                                        display: "flex",
                                        flexDirection: "row",
                                        backgroundColor: "background.paper",
                                        boxShadow: 9,
                                        borderRadius: 2,
                                        padding: 2,
                                    }}
                                >
                                    <Grid container spacing={1} justifyContent="center"
                                        alignItems="center" sx={{
                                            padding: 0,
                                        }}>
                                        <Grid item md={4} xs={6} lg={4} sm={4}>
                                            <TextField
                                                disabled={!isOtherRoleAllowed(OTHER_ADMIN_RIGHTS)}
                                                id="companyName"
                                                label="Company Name"
                                                name="companyName"
                                                placeholder="Company Name"
                                                defaultValue={profileData.companyName}
                                                fullWidth
                                                variant="filled"
                                                size="small"
                                                onChange={(e) => setProfileData(prev => ({
                                                    ...prev,
                                                    companyName: e.target.value,
                                                }))}
                                            />
                                        </Grid>

                                        <Grid item md={4} xs={6} lg={4} sm={4}>
                                            <TextField
                                                disabled
                                                id="userName"
                                                label="Name"
                                                variant="filled"
                                                size="small"
                                                name="userName"
                                                placeholder="Name"
                                                defaultValue={profileData.userName}
                                                fullWidth
                                            />
                                        </Grid>
                                        <Grid item md={4} xs={6} lg={4} sm={4}>
                                            <TextField
                                                disabled
                                                id="userEmail"
                                                label="Email"
                                                name="userEmail"
                                                placeholder="E-mail Address"
                                                defaultValue={profileData.userEmail}
                                                fullWidth
                                                variant="filled"
                                                size="small"

                                            />
                                        </Grid>
                                        <Grid item md={4} xs={6} lg={4} sm={4}>
                                            <TextField
                                                disabled={!isOtherRoleAllowed(OTHER_ADMIN_RIGHTS)}
                                                id="companyMail"
                                                label="Company Mail"
                                                name="companyMail"
                                                placeholder="Company Mail"
                                                defaultValue={profileData.companyMail}
                                                fullWidth
                                                variant="filled"
                                                size="small"
                                                onChange={(e) => setProfileData(prev => ({
                                                    ...prev,
                                                    companyMail: e.target.value,
                                                }))}
                                            />
                                        </Grid>
                                        <Grid item md={4} xs={6} lg={4} sm={4}>
                                            <TextField
                                                disabled={!isOtherRoleAllowed(OTHER_ADMIN_RIGHTS)}
                                                id="companyWebAddress"
                                                label="Web Address"
                                                name="companyWebAddress"
                                                placeholder="Web Address"
                                                defaultValue={profileData.companyWebAddress}
                                                fullWidth
                                                variant="filled"
                                                size="small"
                                                onChange={(e) => setProfileData(prev => ({
                                                    ...prev,
                                                    companyWebAddress: e.target.value,
                                                }))}
                                            />
                                        </Grid>
                                        <Grid item md={4} xs={6} lg={4} sm={4}>
                                            <TextField
                                                disabled
                                                id="startDate"
                                                label="Start Date"
                                                name="startDate"
                                                defaultValue={profileData.startDate}
                                                helperText={<span style={{ whiteSpace: 'pre-wrap', overflowWrap: 'break-word' }}>{"Original Start Date: " + storeActiveShopHash.originalStartDate}</span>}
                                                fullWidth
                                                variant="filled"
                                                size="small"
                                            />
                                        </Grid>
                                        <Grid item md={4} xs={6} lg={4} sm={4}>
                                            <TextField
                                                disabled
                                                id="validity"
                                                label="Remaining Validity"
                                                name="validity"
                                                defaultValue={profileData.validity + " days"}
                                                helperText={<span style={{ whiteSpace: 'pre-wrap', overflowWrap: 'break-word' }}>{"Total Validity: " + storeActiveShopHash.totalValidity + " days"}</span>}
                                                fullWidth
                                                variant="filled"
                                                size="small"
                                            />
                                        </Grid>
                                    </Grid>
                                </Paper>
                            </Grid>
                            <Grid item md={12} xs={12} lg={12} sm={12}>
                                <Paper
                                    elevation={0}
                                    autoHeight
                                    sx={{
                                        display: "flex",
                                        flexDirection: "row",
                                        backgroundColor: "background.paper",
                                        boxShadow: 9,
                                        borderRadius: 2,
                                        padding: 2,
                                    }}>
                                    <Grid container spacing={1} display="flex"
                                        alignItems="center" sx={{
                                            padding: 0.1,
                                        }}>
                                        {CART_INITIAL_STATE.listShopHash.length > 1 &&
                                            <Grid item md={4} xs={12} lg={4} sm={12}>
                                                <Autocomplete
                                                    id="demo-simple-select-label"
                                                    variant="filled"
                                                    size="small"
                                                    autoHighlight
                                                    options={CART_INITIAL_STATE.listShopHash}
                                                    onChange={updateCartValue}
                                                    getOptionLabel={(option) => getKeyByValue(CartDets, option)}
                                                    defaultValue={storeActiveShopHash}
                                                    renderOption={(props, option) => (
                                                        <Box
                                                            component="li"
                                                            {...props}
                                                        >
                                                            {
                                                                storeActiveShopHash.id === option.id ?
                                                                    <Typography textAlign="center" style={{ whiteSpace: 'pre-wrap', overflowWrap: 'break-word', color: "#2f1160", fontWeight: 'bold' }}>{getKeyByValue(CartDets, option)}</Typography>
                                                                    : <Typography textAlign="center" style={{ whiteSpace: 'pre-wrap', overflowWrap: 'break-word' }}>{getKeyByValue(CartDets, option)}</Typography>
                                                            }
                                                        </Box>
                                                    )}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            label="Select Shop Type"
                                                            inputProps={{
                                                                ...params.inputProps,
                                                            }}
                                                            style={{ width: "100%" }}
                                                        />
                                                    )}
                                                />
                                            </Grid>
                                        }
                                        <Grid item md={4} xs={6} lg={4} sm={4}>
                                            <TextField
                                                disabled
                                                id="shopName"
                                                label="Shop Name"
                                                name="shopName"
                                                placeholder="Shop Name"
                                                defaultValue={selShop.shop}
                                                fullWidth
                                                variant="filled"
                                                size="small"

                                            />
                                        </Grid>
                                        <Grid item md={4} xs={6} lg={4} sm={4}>
                                            <TextField
                                                disabled
                                                id="shopAddress"
                                                label="Shop Address"
                                                variant="filled"
                                                size="small"
                                                multiline
                                                name="shopAddress"
                                                onChange={handleInputChange}
                                                placeholder="Shop Address"
                                                defaultValue={selShop.location}
                                                fullWidth
                                            />
                                        </Grid>
                                        <Grid item md={4} xs={6} lg={4} sm={4}>
                                            <TextField
                                                disabled
                                                id="gstDetails"
                                                label="Gst Details"
                                                variant="filled"
                                                size="small"
                                                name="gstDetails"
                                                onChange={handleInputChange}
                                                placeholder="GST Details"
                                                defaultValue={selShop.gstDetail}
                                                fullWidth
                                            />
                                        </Grid>
                                        <Grid item md={4} xs={6} lg={4} sm={4}>
                                            <TextField
                                                id="panDetails"
                                                label="Enter Pan Details"
                                                variant="filled"
                                                size="small"
                                                name="panDetails"
                                                onChange={handleInputChange}
                                                placeholder="Enter Pan Details"
                                                defaultValue={profileData.panDetails}
                                                fullWidth
                                            />
                                        </Grid>
                                        <Grid item xs={12}>
                                            <Typography variant="subtitle1" className="section-title">
                                                Online Pay Methods
                                            </Typography>
                                            <List dense>
                                                {listOnlinePayMethod.map((m, i) => (
                                                    <ListItem
                                                        key={i}
                                                        sx={{
                                                            borderBottom: "1px solid #e0e0e0", // light gray border
                                                            paddingY: "6px",
                                                        }}
                                                        className={!isOtherRoleAllowed(OTHER_ADMIN_RIGHTS) ? "greyed" : ""}
                                                        secondaryAction={
                                                            isOtherRoleAllowed(OTHER_ADMIN_RIGHTS) && (
                                                                <>
                                                                    <IconButton onClick={() => handleMoveMethod(i, i - 1)} disabled={i === 0}>
                                                                        <ArrowUpwardIcon />
                                                                    </IconButton>
                                                                    <IconButton onClick={() => handleMoveMethod(i, i + 1)} disabled={i === listOnlinePayMethod.length - 1}>
                                                                        <ArrowDownwardIcon />
                                                                    </IconButton>
                                                                    <IconButton onClick={() => handleRemoveMethod(i)}>
                                                                        <DeleteIcon />
                                                                    </IconButton>
                                                                </>
                                                            )
                                                        }
                                                    >
                                                        <ListItemText primary={m} />
                                                    </ListItem>
                                                ))}
                                            </List>

                                            <div className="add-method">
                                                <TextField
                                                    size="small"
                                                    placeholder="Add new method"
                                                    value={payMethod}
                                                    onChange={(e) => setPayMethod(e.target.value)}
                                                    disabled={!isOtherRoleAllowed(OTHER_ADMIN_RIGHTS)}
                                                    className={!isOtherRoleAllowed(OTHER_ADMIN_RIGHTS) ? "greyed" : ""}
                                                />
                                                <IconButton onClick={handleAddMethod} disabled={!isOtherRoleAllowed(OTHER_ADMIN_RIGHTS)}>
                                                    <AddIcon />
                                                </IconButton>
                                            </div>
                                        </Grid>
                                    </Grid>
                                </Paper>
                            </Grid>
                            {loyaityPoints &&
                                <Grid item md={12} xs={12} lg={12} sm={12}>
                                    <Paper
                                        elevation={0}
                                        autoHeight
                                        sx={{
                                            display: "flex",
                                            flexDirection: "row",
                                            backgroundColor: "background.paper",
                                            boxShadow: 9,
                                            borderRadius: 2,
                                            padding: 2,
                                        }}
                                    >
                                        <Grid container spacing={1} display="flex"
                                            alignItems="center" sx={{
                                                padding: 0.1,
                                            }}>
                                            <Grid item md={12} xs={12} lg={12} sm={12}>
                                                <FormControl component="fieldset">

                                                    <FormLabel component="legend">
                                                        Set Loylity Point Formula
                                                    </FormLabel>
                                                    <RadioGroup
                                                        aria-label="pointDenom"
                                                        name="pointDenom"
                                                        value={profileData.pointDenom.toString()}
                                                        onChange={handleInputChange}
                                                        row={true}

                                                    >
                                                        <FormControlLabel
                                                            disabled={isNotAllowed}
                                                            value={OfferType.No_Offer.toString()}
                                                            control={<Radio />}
                                                            label="No Formula"
                                                            fullwidth

                                                        />
                                                        <FormControlLabel
                                                            disabled={isNotAllowed}
                                                            value={OfferType.Flat.toString()}
                                                            control={<Radio />}
                                                            label="Flat"
                                                            fullWidth

                                                        />
                                                        <FormControlLabel
                                                            disabled={isNotAllowed}
                                                            value={OfferType.Percentage.toString()}
                                                            control={<Radio />}
                                                            label="Percentage"
                                                            fullwidth
                                                        />
                                                        <FormControlLabel
                                                            disabled={isNotAllowed}
                                                            value={OfferType.ONVALUE_FLAT.toString()}
                                                            control={<Radio />}
                                                            label="Flat Per Some Value"
                                                            fullwidth
                                                        />
                                                        <FormControlLabel
                                                            disabled={isNotAllowed}
                                                            value={OfferType.ONVALUE_PERC.toString()}
                                                            control={<Radio />}
                                                            label="Percentage Per Some Value"
                                                            fullWidth
                                                        />
                                                    </RadioGroup>
                                                </FormControl>
                                            </Grid>
                                            {
                                                (profileData.pointDenom > 1) &&
                                                <Grid item md={4} xs={6} lg={4} sm={4}>
                                                    <TextField
                                                        disabled={isNotAllowed}
                                                        id="pointValue"
                                                        name="pointValue"
                                                        variant="filled"
                                                        size="small"
                                                        label="Enter Point Value"
                                                        value={profileData.pointValue.toString()}
                                                        onChange={handleInputChange}
                                                        fullwidth
                                                    />
                                                </Grid>
                                            }

                                            {
                                                (profileData.pointDenom > 3) &&
                                                <Grid item md={4} xs={6} lg={4} sm={4}>
                                                    <TextField
                                                        disabled={isNotAllowed}
                                                        id="pointDenomVal"
                                                        name="pointDenomVal"
                                                        variant="filled"
                                                        size="small"
                                                        label="Enter Point Denomination Value"
                                                        value={profileData.pointDenomVal.toString()}
                                                        onChange={handleInputChange}
                                                        fullwidth
                                                    />
                                                </Grid>
                                            }
                                            <Grid item md={4} xs={12} lg={4} sm={4}>
                                                <TextField
                                                    disabled={getPointCost()}
                                                    id="pointRealCostPer"
                                                    label="Enter Per Point Cost(Rs)"
                                                    variant="filled"
                                                    size="small"
                                                    name="pointRealCostPer"
                                                    onChange={handleInputChange}
                                                    defaultValue={profileData.pointRealCostPer.toString()}
                                                    fullWidth
                                                />
                                            </Grid>
                                        </Grid>
                                    </Paper>
                                </Grid>
                            }


                            <Grid item md={12} xs={12} lg={12} sm={12}>
                                <Paper
                                    elevation={0}
                                    autoHeight
                                    sx={{
                                        display: "flex",
                                        flexDirection: "row",
                                        backgroundColor: "background.paper",
                                        boxShadow: 9,
                                        borderRadius: 2,
                                        padding: 2,
                                    }}>
                                    <Grid container spacing={2} display="flex" alignItems="flex-start"
                                        sx={{
                                            padding: 0.1, ml: 2
                                        }}>
                                        <Grid item md={12} xs={12} lg={12} sm={12}>
                                            <Typography variant="h5" fontWeight="bold" style={{ color: "rgb(189, 81, 67)", whiteSpace: 'pre-wrap', overflowWrap: 'break-word' }}>Feature Provided to User:</Typography>
                                        </Grid>
                                        <Grid item md={12} xs={12} lg={12} sm={12}>
                                            <Grid container spacing={2}>
                                                {
                                                    Object.keys(CART_INITIAL_STATE.packages).map((key) => (
                                                        <Grid item md={6} xs={12} lg={6} sm={6} key={key}>
                                                            <tr key={key}>
                                                                <td>
                                                                    <Typography variant="p" fontWeight="bold" style={{ color: "#135f2c", whiteSpace: 'pre-wrap', overflowWrap: 'break-word' }} >
                                                                        {key}
                                                                    </Typography>

                                                                    {
                                                                        CART_INITIAL_STATE.packages[key] ? <Tooltip title="Subscribed">
                                                                            <CheckCircleIcon />
                                                                        </Tooltip> :
                                                                            <Tooltip title="Not Subscribed.Ask your agent to subscribe">
                                                                                <CancelIcon />
                                                                            </Tooltip>
                                                                    }

                                                                </td>
                                                            </tr>
                                                        </Grid>



                                                    ))
                                                }
                                            </Grid>
                                        </Grid></Grid>
                                </Paper>
                            </Grid>
                        </Grid>
                        <Grid container spacing={1} justifyContent="center"
                            alignItems="center" sx={{
                                padding: 0, mt: 2,
                            }}>
                            <Grid item md={3} xs={12} lg={3} sm={3}>
                                <SnpButton
                                    variant="contained" mbgcolor="#03396c" onClick={handleProfileSubmit}>
                                    Update Profile
                                </SnpButton>
                            </Grid>

                            {
                                (tableSystemAllowed && storeCartType === CartDets.Resto) &&
                                <Grid item md={3} xs={12} lg={3} sm={3}>
                                    <SnpButton
                                        variant="contained" mbgcolor="#123524" onClick={() => navigate("/dashboard/tableconfig")}>
                                        Table Configuration
                                    </SnpButton>  </Grid>
                            }
                        </Grid>
                    </div>
                    : <Loader />
            }

        </React.Fragment>
    );
}
